export default {
  userLogin: {
    method: 'post',
    url: '/index.php/api/user/login'
  },
  indexIndex: {
    method: 'get',
    url: '/index.php/api/index/index'
  },
  coverSameBooksData: {
    method: 'get',
    url: '/index.php/api/Book/getSameBooks'
  },
  userRegister: {
    method: 'post',
    url: '/index.php/api/user/register'
  },
  userInfo: {
    method: 'get',
    url: '/index.php/api/user/getUserInfo'
  },
  wxScanCode: {
    method: 'get',
    url: '/index.php/api/user/thirdLogin'
  },
  friendLink: {
    method: 'get',
    url: '/index.php/api/common/link'
  },
  bookDetail: {
    method: 'get',
    url: '/index.php/api/Book/detail'
  },
  chapterList: {
    method: 'get',
    url: '/index.php/api/Chapter/chapterList'
  },
  chapterContent: {
    method: 'get',
    url: '/index.php/api/Chapter/content'
  },
  userBookCaseList: {
    method: 'get',
    url: '/index.php/api/user/getBookCase'
  },
  addBookCase: {
    method: 'get',
    url: '/index.php/api/Book/collect'
  },
  isBookCase: {
    method: 'get',
    url: '/index.php/api/Book/isCollect'
  },
  userReadLog: {
    method: 'get',
    url: '/index.php/api/user/getReadLog'
  },
  userMonthLog: {
    method: 'get',
    url: '/index.php/api/user/getMonthLog'
  },
  userRechargeLog: {
    method: 'get',
    url: '/index.php/api/user/getRechargeLog'
  },
  userPayChapterLog: {
    method: 'get',
    url: '/index.php/api/user/getPayChapterLog'
  },
  fetchUserInfo: {
    method: 'get',
    url: '/api/user'
  },
  fetchIndexData: {
    method: 'get',
    url: '/home/Index/index'
  },
  bookReviewList: {
    method: 'get',
    url: '/index.php/api/Book/getReview'
  },
  categoryList: {
    method: 'get',
    url: '/index.php/api/Category/index'
  },
  bookList: {
    method: 'get',
    url: '/index.php/api/Blist/index'
  },
  // 是否添加书架
  fetchIsBookcase: {
    method: 'get',
    url: '/home/Book/is_bookcase'
  },
  fetchUserLogin: {
    method: 'post',
    url: '/home/Login/index'
  },
  fetchSubscribeChapter: {
    method: 'post',
    url: '/home/Booksub/subscribe'
  },
  fetchPayment: {
    method: 'post',
    url: '/home/Payment/index'
  },
  authorInfo: {
    method: 'get',
    url: '/index.php/api/Author/getInfo'
  },
  saveAuthorInfo: {
    method: 'post',
    url: '/index.php/api/AInfo/editInfo'
  },
  getAuthorBookList: {
    method: 'get',
    url: '/index.php/api/Abooks/lists'
  },
  getCategoryList: {
    method: 'get',
    url: '/index.php/api/Category/index'
  },
  createAuthorBook: {
    method: 'post',
    url: '/index.php/api/Abooks/create'
  },
  saveDraft: {
    method: 'post',
    url: '/index.php/api/Achapter/saveDraft'
  },
  addVolume: {
    method: 'post',
    url: '/index.php/api/Achapter/addVolume'
  },
  delVolume: {
    method: 'post',
    url: '/index.php/api/Achapter/delVolume'
  },
  delChapter: {
    method: 'post',
    url: '/index.php/api/Achapter/del'
  },
  delDraft: {
    method: 'post',
    url: '/index.php/api/Achapter/delDraft'
  },
  chapterList: {
    method: 'get',
    url: '/index.php/api/Achapter/lists'
  },
  draftList: {
    method: 'get',
    url: '/index.php/api/Achapter/draftList'
  },
  volumeList: {
    method: 'get',
    url: '/index.php/api/Achapter/volumeList'
  },
  publishChapter: {
    method: 'post',
    url: '/index.php/api/Achapter/publish'
  },
  savePublishChapter: {
    method: 'post',
    url: '/index.php/api/Achapter/savePublishChapter'
  },
  getAuthorBookInfo: {
    method: 'post',
    url: '/index.php/api/Abooks/info'
  },
  getAuthorInfo: {
    method: 'post',
    url: '/index.php/api/Ainfo/getInfo'
  },
  updateAuthorBookInfo: {
    method: 'post',
    url: '/index.php/api/Abooks/updateInfo'
  },
  authorLogin: {
    method: 'post',
    url: '/index.php/api/Author/login'
  }
}

/* static async Userlogin(formData) {
  let url = `${Constant.apipath}/home/Login/index`;
  let data = await this.http_post(url,formData);
  return data;
}
// 退出登录
static async Userlogout(formData) {
  let url = `${Constant.apipath}/home/Logout/index`;
  let data = await this.http_post(url,formData);
  return data;
}

// 用户注册
static async UserRegister(formData) {
  let url = `${Constant.apipath}/home/Login/register`;
  let data = await this.http_post(url,formData);
  return data;
}
// 首页
static async home() {
  let url = `${Constant.apipath}/home/Index/index`;
  let data = await this.http_get(url);
  return data;
}
// 米阅中文
static async MIYUE() {
  let url = `${Constant.apipath}/home/Bookmale/index`;
  let data = await this.http_get(url);
  return data;
}
// 兮阅文学
static async XIYUE() {
  let url = `${Constant.apipath}/home/Bookshort/index`;
  let data = await this.http_get(url);
  return data;
}
// 顶部打赏列表
static async GetSlog() {
  let url = `${Constant.apipath}/home/Index/getpropslog`;
  let data = await this.http_get(url);
  return data;
}
// 底部友情链接
static async FooterLink() {
  let url = `${Constant.apipath}/home/Link/index`;
  let data = await this.http_get(url);
  return data;
}
// 分类
static async Category() {
  let url = `${Constant.apipath}/home/Category/index`;
  let data = await this.http_get(url);
  return data;
}
// 全部小说
static async Booklist(formData) {
  let url = `${Constant.apipath}/home/Booklist/index`;
  let data = await this.http_post(url, formData);
  return data;
}
// 作品详情
static async Detail(id,token) {
  let url = `${Constant.apipath}/home/book/index/id/${id}/token/${token}`;
  let data = await this.http_get(url);
  return data;
}
// 迷妹等级积分获取
static async GetFanrank(formData) {
  let url = `${Constant.apipath}/home/Book/getfanrank`;
  let data = await this.http_post(url,formData);
  return data;
}
// 赠送送礼
static async GiveGift(formData) {
  let url = `${Constant.apipath}/home/Memberinfo/givegift`;
  let data = await this.http_post(url,formData);
  return data;
}
// 是否添加书架
static async IsBookcase(formData) {
  let url = `${Constant.apipath}/home/Book/is_bookcase`;
  let data = await this.http_post(url,formData);
  return data;
}
// 目录
static async Catelog(formData) {
  let url = `${Constant.apipath}/home/Chapter/catelog`;
  let data = await this.http_post(url,formData);
  return data;
}
// 评论内容
static async GetReview(formData) {
  let url = `${Constant.apipath}/home/book/getReview`;
  let data = await this.http_post(url, formData);
  return data;
}
// 发表评论
static async SaveReview(formData) {
  let url = `${Constant.apipath}/home/book/publishReview`;
  let data = await this.http_post(url,formData);
  return data;
}
// 回复评论
static async Replies(formData) {
  let url = `${Constant.apipath}/home/Book/publishReplies`;
  let data = await this.http_post(url,formData);
  return data;
}
// 章节内容
static async GetContent(aid,cid,token) {
  let url = `${Constant.apipath}/home/Chapter/view/aid/${aid}/cid/${cid}/token/${token}`;
  let data = await this.http_get(url);
  return data;
}
// 加入书架
static async AddBookCase(formData) {
  let url = `${Constant.apipath}/home/Memberbookcase/addBookcase`;
  let data = await this.http_post(url,formData);
  return data;
}
// 获取书架
static async BookCaseList(formData) {
  let url = `${Constant.apipath}/home/Memberbookcase/BookCaseList`;
  let data = await this.http_post(url, formData);
  return data;
}
// 财务中心
static async GetFinance(token) {
  let url = `${Constant.apipath}/home/Memberfinance/index/token/${token}`;
  let data = await this.http_get(url);
  return data;
}
// 会员中心
static async Memberinfo(token) {
  let url = `${Constant.apipath}/home/Memberinfo/index/token/${token}`;
  let data = await this.http_get(url);
  return data;
}
// 全部榜单
static async Bookrank(index, page) {
  let url = `${Constant.apipath}/home/Bookrank/${index}/page/${page}`;
  let data = await this.http_get(url);
  return data;
}
// 充值
static async Payment(pname, total_amount, token) {
  let url = `${Constant.apipath}/home/Payment/index/pname/${pname}/total_amount/${total_amount}/token/${token}`;
  let data = await this.http_get(url);
  return data;
}
// 搜索
static async Search(kw,page) {
  let url = `${Constant.apipath}/home/Search/index/kw/${kw}/page/${page}`;
  let data = await this.http_get(url);
  return data;
}
// 购买章节
static async Subscribe(formData) {
  let url = `${Constant.apipath}/home/Booksub/subscribe`;
  let data = await this.http_post(url,formData);
  return data;
}
// 赠送礼物列表
static async GiftData() {
  let url = `${Constant.apipath}/home/Book/giftinfo`;
  let data = await this.http_get(url);
  return data;
}
// 修改昵称
static async EditUname(formData) {
  let url = `${Constant.apipath}/home/Memberinfo/edituname`;
  let data = await this.http_post(url,formData);
  return data;
}
// 书架置顶
static async setBookTop(formData) {
  let url = `${Constant.apipath}/home/Memberbookcase/setBookTop`;
  let data = await this.http_post(url,formData);
  return data;
}
// 删除
static async delBookCase(formData) {
  let url = `${Constant.apipath}/home/Memberbookcase/delBookCase`;
  let data = await this.http_post(url,formData);
  return data;
}
// 迷妹等级积分获取
static async GetUserTicketList(formData) {
  let url = `${Constant.apipath}/home/MemberInfo/index`;
  let data = await this.http_post(url,formData);
  return data;
}
// 投推荐票
static async SendVote(formData) {
  let url = `${Constant.apipath}/home/MemberInfo/domticket`;
  let data = await this.http_post(url,formData);
  return data;
}

}*/